@if (tour) {
  <div class="tour-notes">
    <div fxLayout="row" id="logo-row">
      <app-barcode id="barcode-left" [tour]="tour"></app-barcode>
      <img id="logo" src="assets/img/hahn_logo.png" alt="logo" />
    </div>
    <h1>{{ tour.tourType | titlecase }}</h1>
    <table class="tour-details">
      <tr>
        <td>{{ 'tourNotesList.constructionSite' | translate }}:</td>
        <td class="construction-site">{{ tour.constructionSite.name }}</td>
        <td class="client">{{ 'tourNotesList.customer' | translate }}: {{ tour.customer.name }}</td>
      </tr>
      <tr>
        <td>{{ 'tourNotesList.date' | translate }}:</td>
        <td class="date">{{ tour.appointment.date | date : 'shortDate' }}</td>
      </tr>
      <tr>
        <td>{{ 'tourNotesList.startTime' | translate }}:</td>
        <td class="start-time">
          @if (tour.appointment.startTime) {
            {{ tour.appointment.startTime }} {{ 'tourNotesList.startTimeSuffix' | translate }} {{ tour.appointment.class | appointmentClassAsync }}
          }
        </td>
      </tr>
      <tr>
        <td>{{ 'tourNotesList.drivers' | translate }}:</td>
        <td>
          @for (team of tour.teams; track team) {
            {{ team | driverNames }}
          }
        </td>
      </tr>
    </table>
    <mat-card appearance="outlined" class="material">
      <h2>{{ 'tourNotesList.note' | translate }}:</h2>
      {{ tour.material }}
    </mat-card>
    <mat-card appearance="outlined">
      <h2>{{ 'tourNotesList.retrospectiveNote' | translate }}:</h2>
    </mat-card>
    <div fxLayout="row" id="checkbox-container">
      <div fxLayout="column">
        <div class="checkbox-row">
          <div class="checkbox"></div> {{ 'tourNotesList.constructionSiteCheck' | translate }}
        </div>
        <div class="checkbox-row">
          <div class="checkbox"></div> {{ 'tourNotesList.customerNotOnSiteCheck' | translate }}
        </div>
      </div>
      <app-barcode id="barcode-right" [tour]="tour"></app-barcode>
    </div>
    <div fxLayout="row">
      <div class="signature">
        {{ 'tourNotesList.signatureDriver' | translate }}
      </div>
      <div class="signature signatureClient">
        {{ 'tourNotesList.signatureClient' | translate }}
      </div>
    </div>
  </div>
}
